import { Link } from "react-router-dom";

const BADGES = [
  { icon: "🤖", text: "AI Arduino Assistant" },
  { icon: "⚡", text: "Kode Siap Pakai" },
  { icon: "🎓", text: "Riset STEAM" },
];

function Hero() {
  const scrollToFeatures = () => {
    const el = document.getElementById("features");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section className="lp-hero" id="home">
      {/* Background mesh */}
      <div className="lp-hero-mesh" />
      <div className="lp-hero-blur lp-hero-blur-1" />
      <div className="lp-hero-blur lp-hero-blur-2" />

      <div className="lp-hero-inner">
        {/* Pill badges row */}
        <div className="lp-hero-pills">
          {BADGES.map((b) => (
            <span className="lp-pill" key={b.text}>
              {b.icon} {b.text}
            </span>
          ))}
        </div>

        {/* Main headline */}
        <h1 className="lp-hero-title">
          Belajar Arduino<br />
          <span className="lp-hero-gradient">Lebih Cerdas</span><br />
          dengan AI
        </h1>

        <p className="lp-hero-desc">
          Asisten AI khusus Arduino, ESP32, NodeMCU, dan sistem elektronik.
          Dapatkan kode lengkap, penjelasan mendalam, dan template siap pakai — gratis.
        </p>

        {/* CTA */}
        <div className="lp-hero-cta">
          <Link to="/register" className="lp-btn-primary">
            Mulai Gratis ↗
          </Link>
          <button className="lp-btn-ghost" onClick={scrollToFeatures}>
            Lihat Fitur
          </button>
        </div>

        {/* Stats strip */}
        <div className="lp-stats">
          <div className="lp-stat">
            <span className="lp-stat-val">17+</span>
            <span className="lp-stat-lbl">Template</span>
          </div>
          <div className="lp-stat-sep" />
          <div className="lp-stat">
            <span className="lp-stat-val">4</span>
            <span className="lp-stat-lbl">Platform</span>
          </div>
          <div className="lp-stat-sep" />
          <div className="lp-stat">
            <span className="lp-stat-val">100%</span>
            <span className="lp-stat-lbl">Gratis</span>
          </div>
          <div className="lp-stat-sep" />
          <div className="lp-stat">
            <span className="lp-stat-val">UM</span>
            <span className="lp-stat-lbl">Institusi</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;